/** Use only with Antd Form */
/** Use only with Antd Form */
/** Currently validator will no longer working if using regex from outside 'validator' object */

const validator = {
  validateAccountTailNumber: (_, input) => {
    const regex = /^(?!.*[0]$)\d+$/
    let value = input?.trim()
    if (!value) {
      return Promise.reject(new Error('Vui lòng nhập từ 3-15 chữ số, không kết thúc bằng 0'))
    } else if (value?.length > 15 || value?.length < 3) {
      return Promise.reject(new Error('Vui lòng nhập từ 3-15 chữ số, không kết thúc bằng 0'))
    } else if (!regex.test(value) || value?.length !== input?.length) {
      return Promise.reject(new Error('Vui lòng nhập từ 3-15 chữ số, không kết thúc bằng 0'))
    } else {
      return Promise.resolve()
    }
  },
  validateCompanyName: (_, input) => {
    const regex = /^[a-zA-ZÀ-Ỹ0-9\s,_\-.]+$/
    let value = input?.trim()
    if (!value) {
      return Promise.reject(new Error('Vui lòng nhập tên doanh nghiệp'))
    } else if (value?.length > 35) {
      return Promise.reject(new Error('Tối đa 35 ký tự'))
    } else if (!regex.test(value)) {
      return Promise.reject(new Error('Được phép nhập chữ hoa, thường, tiếng việt có dấu và các ký tự - _ , .'))
    } else {
      return Promise.resolve()
    }
  },
  validateDocumentType: (_, value) => {
    if (!value) {
      return Promise.reject(new Error('Vui lòng chọn loại giấy tờ'))
    } else {
      return Promise.resolve()
    }
  },
  validateDocumentNumber: (_, input) => {
    const regex = /^[a-zA-Z0-9\-_/\\]*$/
    let value = input?.trim()
    if (!value) {
      return Promise.reject(new Error('Vui lòng nhập số giấy tờ'))
    } else if (value?.length > 35) {
      return Promise.reject(new Error('Tối đa 35 ký tự'))
    } else if (!regex.test(value)) {
      return Promise.reject(new Error('Chỉ được phép nhập chữ và số, tối đa 35 ký tự, và 1 số ký tự đặc biệt:  - _ / \\'))
    } else {
      return Promise.resolve()
    }
  },
  validateContactName: (_, input) => {
    const regex = /^[a-zA-ZÀ-Ỹ\s,_\-.]+$/
    let value = input?.trim()
    if (!value) {
      return Promise.reject(new Error('Vui lòng nhập tên người liên hệ'))
    } else if (value?.length > 70) {
      return Promise.reject(new Error('Tối đa 70 ký tự'))
    } else if (!regex.test(value)) {
      return Promise.reject(new Error('Được phép nhập chữ hoa, thường, tiếng việt có dấu và các ký tự - _ , .'))
    } else {
      return Promise.resolve()
    }
  },
  validateContactEmail: (_, input) => {
    const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z0-9]{2,}$/
    let value = input?.trim()
    if (!value) {
      return Promise.reject(new Error('Vui lòng nhập email người liên hệ'))
    } else if (value?.length > 35) {
      return Promise.reject(new Error('Tối đa 35 ký tự'))
    } else if (!regex.test(value)) {
      return Promise.reject(new Error('Không đúng định dạng email'))
    } else {
      return Promise.resolve()
    }
  },
  validateContactPhone: (_, input) => {
    const regex = /^0\d{9,10}$/
    let value = input?.trim()
    if (!value) {
      return Promise.reject(new Error('Vui lòng nhập SĐT người liên hệ'))
    } else if (value?.length !== input?.length) {
      return Promise.reject(new Error('Không được chứa khoảng trắng'))
    } else if (!regex.test(value)) {
      return Promise.reject(new Error('Không đúng định dạng SĐT'))
    } else {
      return Promise.resolve()
    }
  },
  validateCity: (_, value) => {
    if (!value) {
      return Promise.reject(new Error('Vui lòng chọn Thành phố'))
    } else {
      return Promise.resolve()
    }
  },
  validateDistrict: (_, value) => {
    if (!value) {
      return Promise.reject(new Error('Vui lòng chọn Quận huyện'))
    } else {
      return Promise.resolve()
    }
  },
  validateWards: (_, value) => {
    if (!value) {
      return Promise.reject(new Error('Vui lòng chọn Phường xã'))
    } else {
      return Promise.resolve()
    }
  },
  validateBranch: (_, value) => {
    if (!value) {
      return Promise.reject(new Error('Vui lòng chọn Chi nhánh'))
    } else {
      return Promise.resolve()
    }
  },
  validateReferCode: (_, input) => {
    const regex = /^\d{0,10}$/
    let value = input?.trim()
    if (value?.length !== input?.length) {
      return Promise.reject(new Error('Không được chứa khoảng trắng'))
    } else if (value?.length > 0 && !regex.test(value)) {
      return Promise.reject(new Error('Tối đa 10 ký tự số'))
    } else {
      return Promise.resolve()
    }
  },
}

export default validator
